AppBase.module('Entities.Content', function (Module) {
  'use strict'

  var Collection

  var Model = Backbone.RelationalModel.extend({
    url: function () {
      var longform = this.get('longform')
      if (!longform) return null

      var url = new URL(window.location.origin + longform.url())
      url.pathname += '/versions/' + this.id

      return url.pathname
    },

    defaults: {
      content: '',
      formatted_content: '',
      restored_from_version_id: null,
      version_number: null,
    },

    relations: [
      {
        type: Backbone.HasOne,
        key: 'longform',
        keySource: 'longform_id',
        relatedModel: 'AppBase.Entities.Content.Longform',
        includeInJSON: Backbone.Model.prototype.idAttribute,
      },
      {
        type: Backbone.HasOne,
        key: 'user',
        keyDestination: 'user',
        keySource: 'user_id',
        relatedModel: 'OpalMoments.Models.User',
        includeInJSON: true,
      },
    ],
  })
  Module.LongformVersion = Model

  Collection = Backbone.Collection.extend({
    model: Model,

    comparator: function (a, b) {
      return a.id > b.id ? -1 : 1
    },
  })
  Module.LongformVersions = Collection
})
